<template>
<section class="icon-link-boxes px-4 py-5%">
    <div class="max-w-6xl mx-auto">
        <h2 v-if="headline" class="uppercase text-3xl vt:text-4xl text-primary-700 text-center leading-none mb-8" v-html="headline"></h2>
        <SmoothLoader class="grid">
            <div v-for="link in links">
                <a :href="link.url">
                    <h3 class="uppercase text-primary-600 text-xl transition-colors" v-html="link.title"></h3>
                    <p v-if="link.blurb" v-html="link.blurb" class="text-gray-800 text-sm mt-4"></p>
                    <div class="corner-icon absolute right-0 bottom-0 transition-colors text-white bg-primary-700 flex w-10 h-10 items-center justify-center" v-html="link.icon || `<i class='fas fa-arrow-right' aria-hidden='true'></i>`"></div>
                </a>
            </div>
        </SmoothLoader>
    </div>
</section>
</template>

<script>
import { ref, computed, nextTick, watch } from 'vue';
export default {
    
    props: ['data'],

    setup(props) {
        return {
            ...props.data
        }
    }

}
</script>